import type { VoidFunctionComponent } from 'react';
import DropdownButton from '../DropdownButton';
import { STANDARD_COUNT_OPTIONS } from './consts';
import PaginationRange from './PaginationRange';

type Props = {
  //  Current page of visible items
  page: number,
  //  Number of items visible per page
  count: number,
  //  Total number of items available
  totalItems: number,
  //  Function to update the current count
  setCount: (count: number) => void,
  // Optional - Count options
  countOptions?: number[],
};

/**
 * Displays a textual page range and a dropdown to configure how many
 * items are shown per page.
 */
const PaginationFooterCount: VoidFunctionComponent<Props> = ({
  page,
  count,
  totalItems,
  setCount,
  countOptions = STANDARD_COUNT_OPTIONS,
}) => (
  <div className="fossa-pagination-footer__count">
    <div className="fossa-pagination-footer__range">
      <PaginationRange page={page} count={count} totalItems={totalItems} />
    </div>
    <div className="fossa-pagination-footer__dropdown" data-test-id="fossa-pagination-footer-dropdown">
      <DropdownButton
        id="fossa-pagination-footer-count-dropdown"
        title={`${count} per page`}
        onSelect={setCount}
        pullRight
        dropup
      >
        {countOptions.map(countOption => (
          <DropdownButton.Item
            key={countOption}
            eventKey={countOption}
            active={count === countOption}
          >
            {countOption} per page
          </DropdownButton.Item>
        ))}
      </DropdownButton>
    </div>
  </div>
);

export default PaginationFooterCount;
